module.exports = __webpack_public_path__ + "img/download-file.7ac72128.svg";